import request from "../utils/request.js"

import qs from "qs"

export function cache(key,value) {

    if(value!==undefined){
        if(value!=null){
            localStorage.setItem(key,JSON.stringify({data:value}))
        }else {
            localStorage.removeItem(key)
        }
    } else{
        var temp=localStorage.getItem(key)
        if(temp==null){
            return null
        }
        return  JSON.parse(temp).data
    }

    return value
}
//get请求
//get请求
export function get(url,params) {
    return request({
        url: url,
        method: "GET",
        params: params,
        // params:qs.stringify(params, { arrayFormat: 'repeat' })
        // paramsSerializer: function(params) {
        //     return qs.stringify(params, {arrayFormat: 'repeat'})
        // }
        paramsSerializer: function (params) {
                return qs.stringify(params, { arrayFormat: "repeat" });

        },
    })
}
//get请求
export function post(url,params) {

    return request({
        url: url,
        method: "POST",

        data: qs.stringify(params)
    })
}
//查询单条数据
export function info(url,param) {
    return request({
        url: url,
        method: "GET",
        params: param
    })
}

// 删除任务
export function del(url,params) {
    return request({
        url: url,
        method: "DELETE",
        data: qs.stringify(params)
    })
}

// 修改任务
export function edit(url,params) {
    return request({
        url: url,
        method: "PUT",
        data: qs.stringify(params)
    })
}

// 新增任务
export function add(url,params) {
    return request({
        url: url,
        method: "POST",
        data: qs.stringify(params)
    })
}
// 新增任务
export function upload(file,url) {
    let param = new FormData()
    // 将得到的文件流添加到FormData对象
    param.append('file', file, file.name)
    return request({
        url:url,
        headers: { 'Content-Type': 'multipart/form-data' },
        method: "POST",
        data: param
    })
}

